import { useAuth } from '@/AuthProvider'
import { MainLayout } from '@/components/layout/MainLayout'
import { MaintenanceModeToggle } from '@/components/MaintenanceModeToggle'

export function Maintenance() {
  const { auth } = useAuth()

  const isSuperAdmin = auth?.role === 'SUPER_ADMIN'

  return (
    <MainLayout hideBack={true}>
      {/* Maintenance Mode Toggle - Only visible to Super Admins */}
      {isSuperAdmin && (
        <div className="mb-4">
          <MaintenanceModeToggle />
        </div>
      )}
    </MainLayout>
  )
}
